<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'ProgressBar',
  data () {
    return {
      imgURL: 'interactive/indicator-tutorial.png'
    };
  },
  computed: {
    ...mapGetters([
      'level',
      'clearLevel1',
      'clearLevel2'
    ])
  }
});
</script>

<template>
  <div class="interactive-step">
    <div class="interactive-step-main">
      <div class="circle">
        <i v-if="level === 1 || level === 2" class="icon icon-checkmark"/>
        <div class="text">{{$t('tutorial_instruction')}}</div>
      </div>
      <div class="line-default1" :class="{'line__level1': level === 1 || clearLevel1}"/>
      <div class="default-circle" :class="{'circle1': level === 1 || clearLevel1}">
        <i v-if="clearLevel1" class="icon icon-checkmark"/>
        <div class="text">{{$t('tutorial-level1')}}</div>
      </div>
      <div class="line-default2" :class="{'line__level1__level2': level === 1 || clearLevel1, 'line__level2': level === 2}"/>
      <div class="default-circle" :class="{'circle2': level === 2}">
        <i v-if="clearLevel2" class="icon icon-checkmark"/>
        <div class="text">{{$t('tutorial-level2')}}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.interactive-step {
  display: flex;
  justify-content: center;
  &-main {
    width: 244px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .text {
    position: absolute;
    top: -25px;
    width: 110px;
    left: -40px;
    text-align: center;
  }
  .default-circle {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: #e6e6e6;
    position: relative;
    .text {
      top: -29px;
    }
  }
  .line {
    &-default1, &-default2 {
      height: 6px;
      background-color: #e6e6e6;
    }
    &-default1 {
      width: 81px;
    }
    &-default2 {
      width: 85px;
    }
    &__level1 {
      background-image: linear-gradient(to right, #d0c2f9 , #bda8f9);
      background-color: transparent;
      margin-left: -1px;
      margin-right: -1px;
      width: 79px;
      &__level2 {
        width: 81px;
      }
    }
    &__level2 {
      margin-left: -1px;
      background-image: linear-gradient(to right, #bda8f9 , #a88cf9);
      background-color: transparent;
      margin-left: -1px;
      margin-right: -1px;
      width: 79px;
    }
  }
  .circle, .circle1, .circle2 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .text {
      top: -25px;
    }
    .icon-checkmark {
      color: #fff;
      font-size: 20px;
    }
  }
  .circle {
    background-color: #d0c2f9;
  }
  .circle1 {
    background-color: #bda8f9;
  }
  .circle2 {
    background-color: #a88cf9;
  }
}

.progress-image {
  width: calc(100% - 35px);
  margin-right: 35px;
}
</style>
